<template>
  <vs-list-item>
    <p class="capitalize mb-2">{{ day }}</p>
    <div class="flex">
      <flat-pickr
        :config="configdateTimePicker"
        v-model="computedFrom"
        placeholder="Open at"
        :disabled="!computedOpen"
      />

      <feather-icon
        icon="MinusIcon"
        class="mt-2"
        svgClasses="size-15"
      ></feather-icon>

      <flat-pickr
        :config="configdateTimePicker"
        v-model="computedTo"
        placeholder="Close at"
        :disabled="!computedOpen"
      />

      <vs-checkbox v-model="computedOpen" @change="onChange">{{ 'Open' }}</vs-checkbox>
    </div>
  </vs-list-item>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  props: {
    day: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      default: () => {
        return {
          open: false,
          from: '',
          to: ''
        }
      }
    }
  },
  computed: {
    computedOpen: {
      get() {
        return this.data.open;
      },
      set() {
        //
      }
    },
    computedFrom: {
      get() {
        return this.data.from;
      },
      set(val) {
        this.$emit('update', {
          day: this.day,
          open: this.data.open ? true : false,
          from: val,
          to: this.data.to ? this.data.to : ''
        })
      }
    },
    computedTo: {
      get() {
        return this.data.to;
      },
      set(val) {
        this.$emit('update', {
          day: this.day,
          open: this.data.open ? true : false,
          from: this.data.from ? this.data.from : '',
          to: val
        })
      }
    },
  },
  methods: {
    onChange(e) {
      this.$emit('update', {
        day: this.day,
        open: e.target.checked,
        from: this.data.from ? this.data.from : '',
        to: this.data.to ? this.data.to : ''
      })
    },
  },
  data () {
    return {
      showModal: false,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true
      }
    }
  },
  components: { flatPickr }
}
</script>

<style lang="css">
  .vs-list--slot {
    margin-left: 0;
    margin-right: 0;
  }
</style>
